import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import BlockDialogProvider from './components/shared/BlockDialogProvider';
import { TOAST_OPTIONS } from './lib/toastConfig';
import { initAnalytics } from './lib/analytics';
import { installClientErrorReporter } from './lib/clientErrorReporter';
import { CHUNK_RELOAD_KEY } from './lib/lazyWithReload';
import './index.css';

// Install the global error beacon before anything else can crash — catches
// window.onerror + unhandledrejection across the whole app and POSTs to
// /api/client-error. Best-effort; never throws.
installClientErrorReporter();
initAnalytics();

// Stale-chunk recovery (app-wide): after a deploy, an older index.html points at
// chunk hashes that no longer exist, so Vite's module preload 404s. Reload once
// (guarded against loops) to pull the fresh index.html. Complements
// lazyWithReload, which handles the React.lazy import() path.
window.addEventListener('vite:preloadError', () => {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch { /* sessionStorage unavailable — reload anyway, once is better than a crash */ }
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <BlockDialogProvider>
        <App />
        <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />
      </BlockDialogProvider>
    </BrowserRouter>
  </React.StrictMode>
);
